module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/rimTap/tc-custom/9781960436030.jpg?1731381771031",
      "alt": "This image is the cover for the book Ruina o avivamiento"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ruina o avivamiento\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("El problema del cambio y la ruptura de lo convencional Cualquiera que sea el tipo de personas que componen una congregación, constituyen la clase de iglesia que es: ni peor ni mejor, ni más sabia, ni más santa, ni más ardiente ni más adoradora. Para mejorar o cambiar la iglesia, hay que comenzar con el individuo. Sin embargo, entre la variedad de enemigos que tiene el cristiano, hay uno que se destaca porque asecha impidiendo el avance del creyente en cuanto a su desarrollo espiritual y evitando la tarea más noble encomendada a la iglesia: dar a conocer a Cristo y ganar almas para su reino. Ese enemigo es el cambio y cuanto más avanzamos en la vida, menos necesidad de cambiar sentimos. Por eso es absolutamente urgente salir de la rutina para mejorar nuestra vida cristiana. Y ese es el argumento principal que A. W. Tozer plantea en esta obra como una guía para dirigir al creyente a una vida victoriosa en Cristo. En este libro descubrirás temas sumamente interesantes como: El enemigo del cristiano La iglesia y la rutina Tres leyes espirituales Romper lo establecido Un concepto bíblico de la Iglesia Así que rompe con la rutina, adopta el cambio como herramienta de progreso en tu vida espiritual y serás testigo activo del avance de la iglesia triunfante que compró Cristo a precio de sangre.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      A. W. Tozer\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0